import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './advancedMarketing.less'

export default {
    name: "advancedMarketing",
    data() {
        return {
			banner: {
				title: '小精灵高级营销',
				subTitle: '行之有效的“私域+公域”能力，<br>为门店生意持续注入活力。',
				subTitleWap: '行之有效的“私域+公域”能力，为门店生意持续注入活力。',
				videoAlign: 'right',
				info: '',
				features: '· 构建闭环私域流量<br>· 打通公域流量，玩转“公转私”<br>· 全链路会员生命周期运营<br>· 全能力线上线下打通',
				tips: '适合：重视会员和私域运营的中大型和连锁商家，<br>尤其是高客单的泛行业商家。',
				btnTxt: '',
				btnHref: '',
				btnType: 'href',
				video: 'video/advancedMarketing.webm',
				bg: "#FF451A"//#08CA09 "#67C3C4" #F6AE15 #FE4F1C #6F7BD5 
			},
			intro1: {
				title: '构建门店私域流量',
				subtitle: '线下门店经营，流量为基底，运营是关键。<br>小精灵赋能线下商户一整套基于流量会员的拉新、沉淀、运营方法，让运营更简单，增长看得见。',
				pic: 'img/advancedMarketing/banner1.png',
			},
			vip: {
				type: 'vip',
				title:"打通抖音&团购，玩转“公转私”",
				titleBgColor:"#F5A416",
				subTitle: "全面打通公域流量平台，完成公域引流、私域沉淀的流量运营闭环。<br>让更多的顾客都变成门店的私域会员，并持续产生价值。",
				item1:{
					pic: 'img/digitalizeRestaurant/vip1.png',
					btnTxt: '公域平台会员',
					btnLink: '',
					btnType: 'herf'
				},
				item2:{
					pic: 'img/digitalizeRestaurant/vip2.png',
					btnTxt: '门店私域会员',
					btnLink: '',
					btnType: 'herf'
				},
				arrow: 'img/digitalizeRestaurant/vip_arrow.png',
			},
			intro2: {
				pic: 'img/advancedMarketing/banner2.png',
			},
			intro3: {
				title: '极致的会员体验',
				subTitle: '顾客只需一张电子会员卡，即可完成消费购物、会员支付、裂变分享、<br>商城购买等一系列的消费活动，提高品牌好感度和消费体验感。',
				pic: 'img/advancedMarketing/phone.png',
				infos1:[
					{
						title: '品牌效应',
						info: '建立品牌认知，提升品牌信誉'
					},
					{
						title: '高效便捷',
						info: '3秒开卡、4秒储值、多种营销方案、强力吸储'
					},
					{
						title: '数据沉淀',
						info: '会员信息、消费数据、喜爱偏好'
					},
					{
						title: '裂变传播',
						info: '一键分享、分享奖励、分销裂变'
					},
				],
				infos2:[
					{
						title: '支付即核销',
						info: '快速拉新、支付自动积分、会员自动打折、优惠券自动核销'
					},
					{
						title: '卡面自定义',
						info: '颜色、背景、LOGO自主定义'
					},
					{
						title: '多种能力',
						info: '积分、余额、优惠券、小程序、等级多种展示'
					},
					{
						title: '会员支付',
						info: '动态支付码安全高效，支持微信支付、会员支付'
					},
					{
						title: '实时互动',
						info: '会员信息变动通知百分百0成本精准触达'
					},
				]
			},
			intro4: {
				title: '会员拉新与裂变',
				titleBgColor:"#EE801A",
				subtitle: '多渠道吸引和拓展方式，快速聚客。',
				pic: 'img/advancedMarketing/intro4.png',
			},
			intro5: {
				title: '老会员精准营销',
				titleBgColor:"#EE801A",
				subtitle: '提升老客复购率和客单价，营收增长。',
				pic: 'img/advancedMarketing/intro5.png',
			},
			banner3: {
				pic: 'img/advancedMarketing/banner3.png',
			},
			intro6: {
				title: '超级会员营销',
				titleBgColor:"#EE801A",
				subtitle: '设定权益、锁定等级，培养超级忠诚用户。',
				pic: 'img/advancedMarketing/intro6.png',
			},
			intro7: {
				title: '会员持续变现',
				titleBgColor:"#EE801A",
				subtitle: '完成线上布局，让会员持续消费变现。',
				pic: 'img/advancedMarketing/intro7.png',
			},
			banner4: {
				pic: 'img/advancedMarketing/banner4.png',
			},
			intro8: {
				title: '全能力线上线下打通',
				titleBgColor:"#EE801A",
				subtitle: '从线下收银软件，到线上商城会员，全面打通，一体化会员管理和门店运营。',
				pic: 'img/advancedMarketing/intro8.png',
			},
            rollList: [
                {
                    src: "/img/advancedMarketing/roll1.png",
                    size: 2,
                },
                {
                    src: "/img/advancedMarketing/roll2.png",
                    size: 2,
                },
                {
                    src: "/img/advancedMarketing/roll3.png",
                    size: 1,
                },
                {
                    src: "/img/advancedMarketing/roll4.png",
                    size: 2,
                },
				{
					src: "/img/advancedMarketing/roll5.png",
					size: 2,
				},
				{
					src: "/img/advancedMarketing/roll6.png",
					size: 2,
				},
            ],
			version: {
				title: '一键升级',
				subTitle: '一键升级高级数字化版本，开启门店降本增效、营收增长之旅！',
				list: [
				// {
    //                 thumb: '/img/payOverview/version1.png',
    //                 title: '营销优选版',
    //                 info: '轻量化、全自动的小店数字营销工具，轻松玩转营销活动，实现盈利增长。',
				// 	tag: '10万小店点赞',
				// 	tagColor: '#6370CE',
    //                 linkTxt: '一键升级',
    //                 linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
    //                 linkType: 'href',
    //             },
				// {
    //                 thumb: '/img/payOverview/version2.png',
    //                 title: '营销高级版',
    //                 info: '有效构建企业的“私域流量”能力，并打通“公转私”的闭环方案，为门店生意持续注入活力。',
				// 	tag: '泛行业热门爆款',
				// 	tagColor: '#FF451A',
    //                 linkTxt: '一键升级',
    //                 linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
    //                 linkType: 'href',
				// },
				// {
    //                 thumb: '/img/payOverview/version3.png',
    //                 title: '商盟平台板',
    //                 info: '专为想要在区域自建“平台”型的服务商打造，将分散的商户整合形成商家联盟，联合运营，统一变现。',
				// 	tag: '资源变现首选',
				// 	tagColor: '#5CBCBC',
    //                 linkTxt: '一键升级',
    //                 linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
    //                 linkType: 'href',
				// },
				{
                    thumb: '/img/payOverview/version4.png',
                    title: '餐饮高级版',
                    info: '为餐饮商户提供包括收银、扫码点餐、商城、企业微信、企业钱包等全系列能力，全面赋能餐饮商户的数字化和营收增长。',
					tag: '餐饮全面一体化',
					tagColor: '#F5A416',
                    linkTxt: '一键升级',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    linkType: 'href',
				},
				{
                    thumb: '/img/payOverview/version5.png',
                    title: '零售高级版',
                    info: '为零售商户提供从收银支付、供应链、商品、财务、外卖、员工、私域会员等的闭环解决方案。全面赋能零售商户的数字化和营收增长。',
					tag: '连锁扩张必备',
					tagColor: '#001372',
                    linkTxt: '一键升级',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    linkType: 'href',
				},
				{
                    thumb: '/img/payOverview/version6.png',
                    title: '加油站高级版',
                    info: '为加油站提供数字收银、数字营销、数字管理、数字商城、智慧油站等于一体的全站式解决方案。助力油站真正实现降本、提效、增收。',
					tag: '上万油站推荐',
					tagColor: '#00C409',
                    linkTxt: '一键升级',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# 《和众多服务商伙伴一起共创数字商业时代》，快来参与吧。【问卷网提供支持】',
                    linkType: 'href',
				},
				]
			},
        }
    },
    components: {
        skeleton,
        pay,
        QRCode,
        vueSeamlessScroll
    },
    methods: {
		infoMouseOver(index){
			this.intro6.currentIndex = index
			this.intro6.pic = this.intro6.list[index].pic
		}
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
